import {
  LOAD_TEMPLATE_CONTENT,
  LOAD_TEMPLATE_CONTENT_SUCCESS,
  SET_IS_OPEN_SIDEBAR_CHOOSE_SIZE,
} from './constants';

export const initialState = {
  templates: [],
  isLoadingCategoryPageTemplates: false,
  isOpenSidebarChooseSize: false,
};

function homePageReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_TEMPLATE_CONTENT:
      return {
        ...state,
        isLoadingCategoryPageTemplates: true,
      };
    case LOAD_TEMPLATE_CONTENT_SUCCESS:
      return {
        ...state,
        templates: action.payload.templates,
        isLoadingCategoryPageTemplates: false,
      };
    case SET_IS_OPEN_SIDEBAR_CHOOSE_SIZE:
      return {
        ...state,
        isOpenSidebarChooseSize: action.payload,
      };
    default:
      return state;
  }
}

export default homePageReducer;
